export const APP_TITLE = "NEAR IDEAS"
export const APP_PATH = "/nearideas"
export const MIN_DEPOSIT_AMOUNT = "10000000000000000000000000"
